<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col sm="12">
                <b-card>
                    <div slot="header">
                        <strong>Report A Incident</strong>
                    </div>

                    <div>
                        <b-form  @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
                            <b-row>
                                <b-col>
                                    <b-row>
                                        <b-col sm="4" class="pr-0">
                                            <label><b>Incident Level</b></label>&nbsp;<span style="color: red;">*</span><b> :</b>
                                        </b-col>
                                        <b-col sm="8" class="pl-0">
                                            <b-form-group>
                                                <v-select v-model="customer.incidentlevel" 
                                                    name="incidentlevel"
                                                    @change="handleForm"
                                                    v-validate="'required'"
                                                    :class="{
                                                        input: true,
                                                        'is-invalid': errors.has('form-1.incidentlevel'),
                                                    }"
                                                    :options="incidentlevel_list" placeholder="--Select Incident Level--">
                                                </v-select>
                                                <b-input-group class="mb-3">
                                                    <span class="icon has-text-warning">
                                                    <i
                                                        class="fa fa-warning"
                                                        v-show="errors.has('incidentlevel')"
                                                    ></i>
                                                    </span>
                                                    <span
                                                    style="width:240px"
                                                    v-show="errors.has('form-1.incidentlevel')"
                                                    class="help text-danger"
                                                    >{{ errors.first("form-1.incidentlevel") }}</span
                                                    >
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row v-if="incidentfields === true">
                                        <b-col sm="4" class="pr-0" v-if="customer.incidentlevel.value === 'hub'">
                                            <label><b>Hub Name</b></label>&nbsp;<span style="color: red;">*</span><b> :</b>
                                        </b-col>
                                        <b-col sm="8" class="pl-0" v-if="customer.incidentlevel.value === 'hub'">
                                        <b-form-group>
                                            <v-select 
                                                v-model="customer.valueWH" 
                                                name="hubname"
                                                v-validate="'required'"
                                                :class="{
                                                    input: true,
                                                    'is-invalid': errors.has('form-1.hubname'),
                                                }"
                                                :options="optionsWH" 
                                                :label="'name'"
                                                :reduce="option => option.id"
                                                placeholder="---Select Hub---">
                                            </v-select>

                                            <b-input-group class="mb-3">
                                                <span
                                                v-show="errors.has('form-1.hubname')"
                                                class="help text-danger"
                                                >{{ errors.first("form-1.hubname") }} 
                                                </span>
                                            </b-input-group>
                                        </b-form-group>
                                        </b-col>



                                        <b-col sm="4" class="pr-0" v-if="customer.incidentlevel.value === 'vehicle'">
                                            <label><b>Vehicle Number</b></label>&nbsp;<span style="color: red;">*</span><b> :</b>
                                        </b-col>
                                        <b-col sm="8" class="pl-0" v-if="customer.incidentlevel.value === 'vehicle'">
                                            <b-form-group>
                                                <v-select v-model="customer.selected_vehicleno" 
                                                    name="vehicleno"
                                                    v-validate="'required'"
                                                    :class="{
                                                        input: true,
                                                        'is-invalid': errors.has('form-1.vehicleno'),
                                                    }"
                                                    :options="vehicleitems" placeholder="--Select Vehicle Number--">
                                                </v-select>
        
                                                <b-input-group class="mb-3">
                                                    <span
                                                    v-show="errors.has('form-1.vehicleno')"
                                                    class="help text-danger"
                                                    >{{ errors.first("form-1.vehicleno") }} 
                                                    </span>
                                                </b-input-group>
                                                   
                                            </b-form-group>
        
                                        </b-col>

                                        <b-col sm="4" class="pr-0">
                                            <label><b>Select Incident</b></label>&nbsp;<span style="color: red;">*</span><b> :</b>
                                        </b-col>
                                        <b-col sm="8" class="pl-0">
                                            <b-form-group>
                                                <v-select v-model="customer.selected_incidentname" 
                                                    name="incident name"
                                                    v-validate="'required'"
                                                    :class="{
                                                        input: true,
                                                        'is-invalid': errors.has('form-1.incident name'),
                                                    }"
                                                    :options="Incident_list" placeholder="--Select Incident Name--">
                                                </v-select>
                                                <b-input-group class="mb-3">
                                                    <span class="icon has-text-warning">
                                                    <i
                                                        class="fa fa-warning"
                                                        v-show="errors.has('incident name')"
                                                    ></i>
                                                    </span>
                                                    <span
                                                    style="width:240px"
                                                    v-show="errors.has('form-1.incident name')"
                                                    class="help text-danger"
                                                    >{{ errors.first("form-1.incident name") }}</span
                                                    >
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>


                                        <b-col sm="4" class="pr-0" v-if="customer.incidentlevel.value === 'hub'">
                                            <label><b>Upload Photo</b></label><b> :</b>
                                        </b-col>
                                        <b-col sm="5" class="pl-0" v-if="customer.incidentlevel.value === 'hub'">
                                            <b-form-group>
                                                <b-form-file
                                                  type="file"
                                                  v-model="customer.image_file"
                                                  :state="Boolean(image_file)"
                                                  placeholder="Upload Photo" 
                                                  @change="selectFile($event)"
                                                  accept="image/*"
                                                  class="custom-border"
                                                 >
                                                 <template v-slot:file-name>
                                                    {{ fileUploadMessage }}
                                                </template>
                                                  </b-form-file>
                                                
                                                <!-- Code For Progress Bar -->
                                                    <div class="progress" id="progress_bar" style="display:none; margin-top: 7px; margin-bottom: 7px; width: 100%; height: 30px;font-size: 18px; font-weight: bold;">
                                                        <div class="progress-bar progress-bar-info progress-bar-striped"
                                                        role="progressbar"
                                                        :aria-valuenow="progress"
                                                        aria-valuemin="0"
                                                        aria-valuemax="100"
                                                        :style="{height:'30px',text:'20px', align:'center', width:progress + '%'}"
                                                        >
                                                        {{progress}}%
                                                        
                                                        </div>
                                                    </div>
                                                <!-- Code For Progress Bar Ends --> 
                                            </b-form-group>
                                        </b-col>
                                        <b-col sm="3" v-if="customer.incidentlevel.value === 'hub'">
                                            <b-button @click="removeImage" variant="danger" size="sm" class="mt-1">Remove image</b-button>
                                        </b-col>

                                        <b-col sm="4" class="pr-0" v-if="customer.incidentlevel.value === 'hub'">
                                            <label><b>Upload Video</b></label><b> :</b>
                                        </b-col>
                                        <b-col sm="5" class="pl-0" v-if="customer.incidentlevel.value === 'hub'">
                                            <b-form-group>
                                                <b-form-file
                                                    :label-cols="3"
                                                      type="file"
                                                      v-model="customer.video_file"
                                                      :state="Boolean(video_file)"
                                                      placeholder="Upload Video" 
                                                      @change="selectvedioFile($event)"
                                                      accept="video/*"
                                                      class="custom-border"
                                                     >
                                                     <template v-slot:file-name>
                                                    {{ videoUploadMessage }}
                                                </template>
                                                </b-form-file>
                                               
                                                    <!-- Code For Progress Bar -->
                                                        <div class="progress" id="progress_barvideo" style="display:none; margin-top: 7px; margin-bottom: 7px; width: 100%; height: 30px;font-size: 18px; font-weight: bold;">
                                                            <div class="progress-bar progress-bar-info progress-bar-striped"
                                                            role="progressbar"
                                                            :aria-valuenow="progress"
                                                            aria-valuemin="0"
                                                            aria-valuemax="100"
                                                            :style="{height:'30px',text:'20px', align:'center', width:progress + '%'}"
                                                            >
                                                            {{progress}}%
                                                            
                                                            </div>
                                                        </div>
                                                    <!-- Code For Progress Bar Ends --> 
                                            </b-form-group>
                                        </b-col>
                                        <b-col sm="3" v-if="customer.incidentlevel.value === 'hub'">
                                            <b-button @click="removeVideo" variant="danger" size="sm" >Remove Video</b-button>
                                        </b-col>


                                        <b-col sm="4" class="pr-0" v-if="customer.incidentlevel.value === 'vehicle'">
                                            <label><b>Upload Photo</b></label>&nbsp;<span style="color: red;">*</span><b> :</b>
                                        </b-col>
                                        <b-col sm="5" class="pl-0" v-if="customer.incidentlevel.value === 'vehicle'">
                                            <b-form-group>
                                                <b-form-file
                                                  type="file"
                                                  v-model="customer.image_file"
                                                  :state="Boolean(image_file)"
                                                  placeholder="Upload Photo" 
                                                  @change="selectFile($event)"
                                                  accept="image/*"
                                                  v-validate="'required|'"
                                                   :class="{'image_file': true, 'is-invalid': errors.has('form-1.image_file') }">
                                                   <template v-slot:file-name>
                                                    {{ fileUploadMessage }}
                                                </template>
                                                  </b-form-file>
                                                <b-input-group class="mb-3">
                                                    <span class="icon has-text-warning">
                                                    <i
                                                        class="fa fa-warning"
                                                        v-show="errors.has('image_file')"
                                                    ></i>
                                                    </span>
                                                    <span
                                                    v-show="errors.has('form-1.image_file')"
                                                    class="help text-danger"
                                                    >{{ errors.first("form-1.image_file") }}</span
                                                    >
                                                </b-input-group>
                                                <!-- Code For Progress Bar -->
                                                    <div class="progress" id="progress_bar" style="display:none; margin-top: 7px; margin-bottom: 7px; width: 100%; height: 30px;font-size: 18px; font-weight: bold;">
                                                        <div class="progress-bar progress-bar-info progress-bar-striped"
                                                        role="progressbar"
                                                        :aria-valuenow="progress"
                                                        aria-valuemin="0"
                                                        aria-valuemax="100"
                                                        :style="{height:'30px',text:'20px', align:'center', width:progress + '%'}"
                                                        >
                                                        {{progress}}%
                                                        
                                                        </div>
                                                    </div>
                                                <!-- Code For Progress Bar Ends --> 
                                            </b-form-group>
                                        </b-col>
                                        <b-col sm="3" v-if="customer.incidentlevel.value === 'vehicle'">
                                            <b-button @click="removeImage" variant="danger" size="sm" class="mt-1">Remove image</b-button>
                                        </b-col>

                                        <b-col sm="4" class="pr-0" v-if="customer.incidentlevel.value === 'vehicle'">
                                            <label><b>Upload Video</b></label>&nbsp;<span style="color: red;">*</span><b> :</b>
                                        </b-col>
                                        <b-col sm="5" class="pl-0" v-if="customer.incidentlevel.value === 'vehicle'">
                                            <b-form-group>
                                                <b-form-file
                                                    :label-cols="3"
                                                      type="file"
                                                      v-model="customer.video_file"
                                                      :state="Boolean(video_file)"
                                                      placeholder="Upload Video" 
                                                      @change="selectvedioFile($event)"
                                                      accept="video/*"
                                                      v-validate="'required|'"
                                                       :class="{'video_file': true, 'is-invalid': errors.has('form-1.video_file') }">
                                                       <template v-slot:file-name>
                                                    {{ videoUploadMessage }}
                                                </template>
                                                </b-form-file>
                                                <b-input-group class="mb-3">
                                                        <span class="icon has-text-warning">
                                                        <i
                                                            class="fa fa-warning"
                                                            v-show="errors.has('video_file')"
                                                        ></i>
                                                        </span>
                                                        <span
                                                        v-show="errors.has('form-1.video_file')"
                                                        class="help text-danger"
                                                        >{{ errors.first("form-1.video_file") }}</span
                                                        >
                                                </b-input-group>
                                                    <!-- Code For Progress Bar -->
                                                        <div class="progress" id="progress_barvideo" style="display:none; margin-top: 7px; margin-bottom: 7px; width: 100%; height: 30px;font-size: 18px; font-weight: bold;">
                                                            <div class="progress-bar progress-bar-info progress-bar-striped"
                                                            role="progressbar"
                                                            :aria-valuenow="progress"
                                                            aria-valuemin="0"
                                                            aria-valuemax="100"
                                                            :style="{height:'30px',text:'20px', align:'center', width:progress + '%'}"
                                                            >
                                                            {{progress}}%
                                                            
                                                            </div>
                                                        </div>
                                                    <!-- Code For Progress Bar Ends --> 
                                            </b-form-group>
                                        </b-col>
                                        <b-col sm="3" v-if="customer.incidentlevel.value === 'vehicle'">
                                            <b-button @click="removeVideo" variant="danger" size="sm" >Remove Video</b-button>
                                        </b-col>

                                        <b-col sm="4">
                                            <label><b>Time to Resolve</b></label>&nbsp;<span style="color: red;">*</span><b> :</b>
                                        </b-col>
                                        <b-col sm="8">
                                            <b-col sm="6">
                                            <input v-model="customer.timetoResolve" 
                                                class="form-control" 
                                                type="text" 
                                                id="startTime"
                                                placeholder="HH:MM"
                                                :class="{'is-invalid': errors1.timetoResolve}">
                                            <span v-if="errors1.timetoResolve" class="text-danger">
                                                {{ errors1.timetoResolve }}
                                            </span>
                                        </b-col>


                                            <!-- <b-col sm="6">
    <input v-model="customer.timetoResolve" 
           class="form-control" 
           type="text" 
           id="startTime"
           placeholder="HH:MM"
           :class="{
               input: true,
               'is-invalid': errors.has('form-1.timetoResolve'),
           }">
</b-col> -->


                                            <b-input-group class="mb-3">
                                                    <span class="icon has-text-warning">
                                                    <i
                                                        class="fa fa-warning"
                                                        v-show="errors.has('timetoResolve')"
                                                    ></i>
                                                    </span>
                                                    <span
                                                    style="width:240px"
                                                    v-show="errors.has('form-1.timetoResolve')"
                                                    class="help text-danger"
                                                    >{{ errors.first("form-1.timetoResolve") }}</span
                                                    >
                                                </b-input-group>
                                        </b-col>
                                    </b-row>
                                </b-col>

                                <b-col>
                                    <b-row v-if="incidentfields === true">
                                        <b-col sm="3" class="pr-0">
                                          <label><b>comment</b></label>&nbsp;<span style="color: red;">*</span><b> :</b>
                                        </b-col>
                                        <b-col sm="8" class="pl-0">
                                            <b-form-group>
                                                <b-form-textarea id="textarea" name="comment"  v-validate="'required'" v-model="customer.comment" placeholder="Enter comment" rows="10" :class="{'comment': true, 'is-invalid': errors.has('form-1.comment') }"></b-form-textarea>
                                                <b-input-group class="mb-3">
                                                    <span class="icon has-text-warning">
                                                        <i class="fa fa-warning" v-show="errors.has('comment')"></i>
                                                    </span>
                                                    <span v-show="errors.has('form-1.comment')"
                                                        class="help text-danger">{{ errors.first("form-1.comment") }}
                                                    </span>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-row>
                            <hr>
                            <br>
                            <footer class="float-right">
                                <b-button variant="primary" size="md" type="submit"
                                :disabled="isReadOnly">Report Incident
                                </b-button
                                >&nbsp;
                                <b-button
                                    variant="primary"
                                    size="md"
                                    type="submit"
                                    @click="$router.push('/incident_master')"
                                    >Cancel
                                </b-button>
                            </footer>
                            <br>
                        </b-form>
                    </div>
                </b-card>
            </b-col>
        </b-row>      
    </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import auth from '@/utils/auth'
const axios = require('axios')
export default {
    data() {
        return {
            customer : {
                timetoResolve: '',
            },
            // selected_vehicleno :'',
            // selected_incidentname :'',
            // comment :'',
            vehicleitems : [],
            Incident_list :[],
            progress:0,
            selected_imagefile:'',
            selectedfile_type :'',
            // image_file :'',
            uploadedphoto :'',
            selected_videofile :'',
            // video_file :'',
            uploadedvideo :'',
            incidentlevel_list: [{value:"hub", label: 'Hub Level'},{value:"vehicle", label: 'Vehicle Level'}],
            incidentfields: false,
            optionsWH:[],
            showSelectAll : true,
            WHData:[],
            errors1: {
                timetoResolve: null
            },
            fileUploadMessage: '', // To hold the upload message
            videoUploadMessage: '', // To hold the upload message
            accessBody:[],
            isReadOnly:false,
        }
    },
    created() {
        var userdata = localStorage.getItem("userData");
         var userInfo = JSON.parse(userdata);
        console.log("userInfo",userInfo)
        this.accessBody = userInfo.body;
    console.log("--------->>>>>>>>>>",userInfo.body)
    this.ischeckbodyvalidation();
        this.displaydata();
        this.incidentList();
        this.showWHlist();
    },

    

    methods: {
        ischeckbodyvalidation(){
            for (let i = 0; i < this.accessBody.length; i++) {
                const element = this.accessBody[i];
            
                if (element.title=='Incident Master' && element.isReadonly==true) {
                  this.isReadOnly=true
                }
            if (element.child) {
                for (let j = 0; j < element.child.length; j++) {
                const k = element.child[j];
                if (k.title=='Incident Master' && k.isReadonly==true) {
                    this.isReadOnly=true
                }
                }
            }
            }
            console.log(" this.isReadOnly", this.isReadOnly)
        },
        removeImage : function () {
            this.customer.image_file = '';
            console.log( this.customer.image_file )
        },

        removeVideo : function () {
            this.customer.video_file = '';
        },

        validateForm(scope) {
            this.validateTime(this.customer.timetoResolve);
            this.$validator.validateAll(scope).then((result) => {
                if (result && this.errors1.timetoResolve === null) {
                this.reportincident();
                }
            });
        },

        reportincident : function () {
            document.getElementById("overlay").style.display = "block";
            // incidentReport
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            const reportincd =  {
                incident_id : this.customer.selected_incidentname.key,
                vehicle_id: this.customer && this.customer.selected_vehicleno ? this.customer.selected_vehicleno.key : null,
                report_comment : this.customer.comment==null ? "" :this.customer.comment,
                report_image : this.uploadedphoto ? this.uploadedphoto : null,
                report_video : this.uploadedvideo ? this.uploadedvideo : null,
                createdby : `${userInfo.sysemailid}`,
                incidentlevel: this.customer.incidentlevel.value,
                hubid: this.customer && this.customer.valueWH ? this.customer.valueWH.id : null,
                ttr: this.customer.timetoResolve
            };
            console.log("obj",reportincd)
            // return false
            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/incidentReport`,reportincd).then(result => {
                document.getElementById("overlay").style.display = "none";
                if (result.body.returnmsg === "Successful") {
                    this.$fire({
                        text: "Updated Successfully",
                        type: "success",
                        timer: 30000,
                    });

                    this.selected_incidentname = "";
                    this.selected_vehicleno = "";
                    this.comment = "";
                    this.selected_imagefile = "";
                    this.selected_videofile = "";
                    this.$router.push("/open_incident");
                } else {
                    this.$fire({
                    text: result.body.returnvalue,
                    type: "error",
                    timer: 300000,
                    });
                }
            })
        },

        displaydata: function() {
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            this.vehicleitems=[];
            const deliveryagentobj = {};
            console.log('deliveryagentobj',deliveryagentobj);
            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/incidentVehicleListing`,deliveryagentobj
            )
            .then(result => {
            console.log("YYY",result);
            if (result.body.returnmsg === "Successful") {
                this.vehicleitems  = result.body.returnvalue;
                console.log("vehicle", this.vehicleitems)
                var data = [];
 
                    result.body.returnvalue.forEach(function (srData) {
                        data.push({
                        key:srData.vehicle_id,
                        label:srData.vehicle_no
                        });
                    });
                    this.vehicleitems = data;
                }else{
                  this.vehicleitems  = [];
                }
            })
            .catch(ex => {
            console.log("error", ex);
            });
        
        },

        incidentList : function () {
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            let obj = {};
            if ((this.customer.incidentlevel && this.customer.incidentlevel.value) === "hub") {
                obj = {
                status:"1",
                incidentlevel: "hub"
                };
            }
            
            if ((this.customer.incidentlevel && this.customer.incidentlevel.value) === "vehicle") {
                obj = {
                status:"1",
                incidentlevel: "vehicle"
                };
            }

            // return false
            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/incidentList`,obj).then(result => {
                if (result.body.returnmsg === 'Successful') {
                    this.Incident_list = result.body.returnvalue;
                    // console.log("Incident list",this.Incident_list)
                    var data = [];
 
                    result.body.returnvalue.forEach(function (srData) {
                        data.push({
                        key:srData.incident_id,
                        label:srData.incident_name
                        });
                    });
                    this.Incident_list = data;
                    // console.log("this.Incident_list",this.Incident_list)
                } else {
                    this.Incident_list = [];
                }
            })
        },

        selectFile(event){
      
            this.selected_imagefile= event.target.files[0];
            console.log("yyyyy",this.selected_imagefile);
            if (this.selected_imagefile) {
                this.fileUploadMessage = '1 Photo uploaded'; // Update message when a file is uploaded
            } else {
                this.fileUploadMessage = ''; // Reset the message if no file is uploaded
            }
            this.selectedfile_type=this.selected_imagefile.type;
            console.log("yyyyy",this.selectedfile_type);
            this.uploadphoto(this.selected_imagefile);

        },

        uploadphoto : function () {
            document.getElementById("progress_bar").style.display = "block";
            document.getElementById("overlay").style.display = "block";
            var userData = localStorage.getItem('userData');
            var userInfo = JSON.parse(userData);

            // if (this.selectedfile_type == "image/*") {

                let data = new FormData();
                data.append('file', this.selected_imagefile)
                this.progress=0;
                let config = {
                    header : {
                        'Content-Type' : 'multipart/form-data'
                    }
                }

                axios.post(`${CONSTANTS.MIGRATION_API_URL}/uploadfiletos3`,data, 
                    {
                        header : { 'Content-Type' : 'multipart/form-data'
                        }, 
                        onUploadProgress:function(progressEvent){
                        this.progress=Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        }.bind(this)})
                .then(response => {
                    document.getElementById("overlay").style.display = "none";
                    console.log("responce",response)

                    if (response.data.result=='success') {
                        this.$fire({
                            text:"File Uploaded.Please Submit",
                            type: "success",
                            timer: 300000
                        })
                        this.uploadedphoto=response.data.image_url;
                        console.log("TTTT",this.uploadedphoto);
                        document.getElementById("progress_bar").style.display = "none";
                    } else {
                        this.$fire({
                            text:"File Not Uploaded",
                            type: "error",
                            timer: 300000
                        })
                        document.getElementById("progress_bar").style.display = "none";
                    }
                })
                .catch(e => {
                    this.errors.push(e)
                })
            // } 
            // else {
            //     this.$fire({
            //         text:"Please Upload Photo",
            //         type: "error",
            //         timer: 300000
            //     })
            //     this.selected_imagefile='';
            //     document.getElementById("overlay").style.display = "none";
            //     document.getElementById("progress_bar").style.display = "none";      
            // }
        },

        selectvedioFile(event) {
            this.selected_videofile= event.target.files[0];
            console.log("yyyyy",this.selected_videofile);
            if (this.selected_videofile) {
                this.videoUploadMessage = '1 Video uploaded'; // Update message when a file is uploaded
            } else {
                this.videoUploadMessage = ''; // Reset the message if no file is uploaded
            }
            this.selectedfile_type=this.selected_videofile.type;
            console.log("yyyyy",this.selectedfile_type);
            this.uploadvideo(this.selected_videofile);
        },
        
        uploadvideo : function () {
            document.getElementById("progress_barvideo").style.display = "block";
            document.getElementById("overlay").style.display = "block";
            var userData = localStorage.getItem('userData');
            var userInfo = JSON.parse(userData);

            // if (this.selectedfile_type == "image/*") {

                let data = new FormData();
                data.append('file', this.selected_videofile)
                this.progress=0;
                let config = {
                    header : {
                        'Content-Type' : 'multipart/form-data'
                    }
                }

                axios.post(`${CONSTANTS.MIGRATION_API_URL}/uploadfiletos3`,data, 
                    {
                        header : { 'Content-Type' : 'multipart/form-data'
                        }, 
                        onUploadProgress:function(progressEvent){
                        this.progress=Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        }.bind(this)})
                .then(response => {
                    document.getElementById("overlay").style.display = "none";
                    console.log("responce",response)

                    if (response.data.result=='success') {
                        this.$fire({
                            text:"File Uploaded.Please Submit",
                            type: "success",
                            timer: 300000
                        })
                        this.uploadedvideo=response.data.image_url;
                        console.log("TTTT",this.uploadedvideo);
                        document.getElementById("progress_barvideo").style.display = "none";
                    } else {
                        this.$fire({
                            text:"File Not Uploaded",
                            type: "error",
                            timer: 300000
                        })
                        document.getElementById("progress_barvideo").style.display = "none";
                    }
                })
                .catch(e => {
                    this.errors.push(e)
                })
            // } 
            // else {
            //     this.$fire({
            //         text:"Please Upload Photo",
            //         type: "error",
            //         timer: 300000
            //     })
            //     this.selected_imagefile='';
            //     document.getElementById("overlay").style.display = "none";
            //     document.getElementById("progress_bar").style.display = "none";      
            // }
        },

        handleForm: function () {
            if (this.customer.selected_incidentname && this.customer) {
                this.customer.selected_incidentname = null;
            }
           
            if (this.customer && this.customer.incidentlevel === null) {
                this.incidentfields= false
            }
            if ((this.customer.incidentlevel && this.customer.incidentlevel.value) === 'hub' || (this.customer.incidentlevel && this.customer.incidentlevel.value) === 'vehicle') {
                    this.incidentfields= true
            }
            this.incidentList();
        },

        showWHlist:function(){
          
          var userdata = localStorage.getItem('userData')
          var userInfo = JSON.parse(userdata)
          
          var csvObj = {
              sysusermasterid:`${userInfo.sysusermasterid}`,
              usertype:`${userInfo.user_type}`
          };
          this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getAllHubListing`, csvObj)
            .then(result => {
              
              if (result.body.returnmsg === 'Successful') {
                  this.optionsWH=[];
              
                  this.WHData  = result.body.returnvalue;
                  
                  for(let j = 0; j < this.WHData.length; j++) {
                      let WH = {
                      name: this.WHData[j].hubname + " - " + this.WHData[j].hubid,
                      id: this.WHData[j].hubid,
                      }
                  this.optionsWH.push(WH);
                  }
              
              } else {              
                  this.WHData  = result.body.returnvalue;
              }
          

          })
          .catch(ex => {
              console.log("error-----", ex);
          });
        },

        validateTime(value) {
            console.log('aaavalue', value)
      // const timePattern = /^([0-9]+):([0-9]{2})$/;
      const timePattern = /^([0-9]+):([0-9]{2})$/;

      if (timePattern.test(value)) {
        const [hours, minutes] = value.split(':').map(Number);

        if (hours >= 0 && minutes >= 0 && minutes < 60) {
          this.errors1.timetoResolve = null; // Valid time, clear error
        } else {
          this.errors1.timetoResolve = 'Invalid time format. Hours must be >= 0 and minutes must be < 60.';
        }
      } else {
        this.errors1.timetoResolve = 'Invalid time format. Please use HH:MM format.';
      }
    }
  
    },

    watch: {
        'customer.timetoResolve'(newVal) {
        this.validateTime(newVal);
        }
    },

}
</script>

<style>
.form-control-file {
    margin-top: 0px !important;
}

.custom-border {
  border-color: none !important;
  /* Add other custom styles here */
}
</style>